import type { Theme } from "@mui/material/styles";
import { styled } from "../../../../lib/styled";
import type { FeedOutcomeKey } from "../../../../lib/corpusFeedView";

/** Where each kind of outcome takes its colour from. The one place that says so, so the bar and
 *  its legend cannot disagree. */
const OUTCOME_COLOR = {
  ingested: (theme: Theme) => theme.palette.success.main,
  needs_review: (theme) => theme.palette.warning.main,
  rejected: (theme) => theme.palette.error.main,
  existing: (theme) => theme.palette.info.main,
  failed: (theme) => theme.palette.text.disabled,
  open: (theme) => theme.palette.action.disabled,
} satisfies Record<FeedOutcomeKey, (theme: Theme) => string>;

interface FeedOutcomeSwatchProps {
  $outcome: FeedOutcomeKey;
}

/** A patch of the colour of one kind of outcome; the bar sizes it as a slice, the legend as a dot. */
export const FeedOutcomeSwatch = styled("span")<FeedOutcomeSwatchProps>(({ theme, $outcome }) => ({
  display: "inline-block",
  backgroundColor: OUTCOME_COLOR[$outcome](theme),
}));
